import { colors } from '@/constants/colors'
import { Pressable } from '@/ui/core/pressable'
import { Ionicons } from '@expo/vector-icons'
import { Image } from 'expo-image'
import { Modal, ScrollView, StatusBar, View, useWindowDimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

/**
 * A photo on black, edge to edge, pinch to zoom, a disc to close. The zoom is the scroll
 * view's own, so it behaves like the Photos app.
 */
export const PhotoViewer = ({
	uri,
	label,
	onClose,
}: { uri: string | null; label?: string; onClose: () => void }) => {
	const { width, height } = useWindowDimensions()
	const insets = useSafeAreaInsets()
	return (
		<Modal
			visible={!!uri}
			animationType="fade"
			onRequestClose={onClose}
			statusBarTranslucent
		>
			<StatusBar barStyle="light-content" />
			<View className="flex-1 bg-ink">
				<ScrollView
					contentContainerStyle={{ width, height }}
					maximumZoomScale={4}
					minimumZoomScale={1}
					bouncesZoom
					centerContent
					showsHorizontalScrollIndicator={false}
					showsVerticalScrollIndicator={false}
				>
					{!!uri && (
						<Image
							source={{ uri }}
							accessibilityLabel={label}
							contentFit="contain"
							style={{ width, height }}
						/>
					)}
				</ScrollView>
				<Pressable
					onPress={onClose}
					accessibilityRole="button"
					accessibilityLabel="Close"
					haptic={false}
					className="absolute right-4 h-11 w-11 items-center justify-center rounded-full bg-white/20"
					style={{ top: insets.top + 8 }}
				>
					<Ionicons name="close" size={24} color={colors.white} />
				</Pressable>
			</View>
		</Modal>
	)
}
